import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";

import commonReducer from "./reducers/common";
import homeReducer from "./reducers/home";
import projectsReducer from "./reducers/projects";

const rootReducer = combineReducers({
    common: commonReducer,
    home: homeReducer,
    projects: projectsReducer,
});

// * The window. arguments is used by redux-devtool-extension to debug the redux ations & store values.
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const Store = createStore(
    rootReducer,
    applyMiddleware(thunk)
    // composeEnhancers(applyMiddleware(thunk))
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default Store;

/* ------------- Note -------------
* redux-persist pkg is not helpful cos it only provides to persistence n rehydrating redux store
! But doesn't help in actual reduction of calls that are made to fetch the prerequisite data on a web-pg
* prerequisite is the data common to all the viewers & its fetched everytime the component mounts
*/
